// @material-ui/core components
import {
  // Button, Icon, InputAdornment,
  ClickAwayListener,
  Icon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  TextField,
} from '@material-ui/core';
import { debounce } from 'lodash-es';
import React, { MouseEvent } from 'react';

import { getPublisher, IPublisher, ResourceActiveEnabled } from '~/src/dash/api/console-api';
import { IPublisherNames } from '~/src/dash/api/publishers/publishers_models';
import { IModel } from '~/src/dash/components/model';
import { fontSizing } from '~/src/dash/publicaUI';
import { IBaseState, IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import {
  blackColor,
  iconButton,
  primaryColor,
  whiteColor,
} from '~/src/dash/utils/material-dashboard-react';

// This component is a modified copy of the model-select-view to enable specific Publisher specific features
// Allows for reselller name to be appended to the visible name on model if option is selected

// Extend model to reseller name to be appended if necessary
export interface IModelPublisher extends IModel {
  Reseller?: any;
}

export interface IProps {
  clear?: boolean;
  model?: IModelPublisher;
  models?: IModelPublisher[];
  defaultText?: string;
  maskModel?: boolean;
  maskedModelPrefix?: string;
  appendReseller?: boolean;

  label: React.ReactNode | string;
  helperText?: string;
  searchHelperText?: string;
  onSelect?: (model?: IModelPublisher) => void;
  queryV2: (query: string) => Promise<[IPublisherNames[] | undefined, string | undefined]>;

  TextFieldProps?: any;
  InputLabelProps?: any;
  InputProps?: any;
  search?: string;
}

export interface IState extends IBaseState {
  openSearch: boolean;
  existingQuery: string;
  searchInprogress: boolean;
  countInprogress: number;

  model?: IModelPublisher;
  models: IModelPublisher[];
}

export const ModelPublisherSelectView = decorate(
  {
    router: true,
    styles: () => ({
      searchInputRoot: {
        '&:before': {
          borderBottomColor: blackColor,
        },
        '&:after': {
          borderBottomColor: primaryColor[0],
        },
      },

      popper: {
        background: whiteColor,
        'z-index': 100,
        width: '100%',
        marginLeft: '18px',
        top: '0px',
      },
      clearButton: iconButton,
    }),
  },
  class extends React.Component<IProps & IWithStylesProps, IState> {
    state = {
      openSearch: false,
      existingQuery: '',
      searchInprogress: false,
      countInprogress: 0,

      model: this.props.model,
      models: (this.props.models || []) as IModelPublisher[],

      maskModel: !!this.props.maskModel,
      maskedModelPrefix: this.props.maskedModelPrefix || 'demo',
    };

    searchInputRef = React.createRef();
    anchorEl: HTMLInputElement;

    handleCloseSearch = debounce(() => {
      if (this.state.existingQuery !== '') {
        this.requestModels('');
      }
      this.setState({
        existingQuery: '',
        openSearch: false,
      });
    }, 100);

    _requestModels = debounce((query: string, countInprogress: number) => {
      if (this.state.countInprogress !== countInprogress) {
        return;
      }

      // v2
      this.props.queryV2(query).then(
        ([models, err]) => {
          if (this.state.countInprogress !== countInprogress) {
            return;
          }

          if (err !== undefined) {
            console.error(err);
          }

          const publishers = [] as IModelPublisher[];
          if (models !== undefined) {
            models.forEach((m: IPublisherNames) => {
              publishers.push({
                ID: m.id,
                Name: m.name,
                Active: ResourceActiveEnabled,
                Reseller: { Name: m.reseller_name === '' ? undefined : m.reseller_name },
              } as any as IModelPublisher);
            });
          }

          this.setState({
            searchInprogress: false,
            models: publishers,
          });
        },
        () => {
          if (this.state.countInprogress !== countInprogress) {
            return;
          }
          this.setState({
            searchInprogress: false,
          });
        },
      );
    }, 100);

    requestModels = (query: string) => {
      const countInprogress = this.state.countInprogress + 1;
      this.setState(
        {
          searchInprogress: true,
          countInprogress,
        },
        () => this._requestModels(query, countInprogress),
      );
    };

    // Renders the model text with reseller name if option is enabled
    renderModel = (model: IModelPublisher, appendReseller: boolean) => {
      let reseller = '';
      // Add the reseller name if enabled and exists
      if (appendReseller && model.Reseller.Name !== undefined && model.Reseller.Name !== '') {
        reseller = ' (' + model.Reseller.Name + ')';
      }
      const modelText = this.state.maskModel
        ? `${this.state.maskedModelPrefix}_${model.ID}`
        : `[${model.ID}] ${model.Name}`;

      return (
        <div>
          {modelText}
          <b>{reseller}</b>
        </div>
      );
    };
    renderSelectedModel = (appendReseller: boolean) => {
      let reseller = '';
      // Add the reseller name if enabled and exists
      if (
        appendReseller &&
        this.state.model !== undefined &&
        this.state.model.Reseller.Name !== undefined &&
        this.state.model.Reseller.Name !== ''
      ) {
        reseller = ' (' + this.state.model.Reseller.Name + ')';
      }

      return this.state.model
        ? this.state.maskModel
          ? `${this.state.maskedModelPrefix}_${this.state.model.ID}${reseller}`
          : `[${this.state.model.ID}] ${this.state.model.Name}${reseller}`
        : this.props.defaultText !== undefined
        ? this.props.defaultText
        : 'All';
    };

    handleOpenSearch = () => {
      this.setState({
        openSearch: true,
      });

      if ('focus' in this.searchInputRef) {
        // @ts-ignore
        this.searchInputRef.focus();
      }
    };

    selectModel = ({ currentTarget }: MouseEvent<HTMLLIElement>) => {
      const model = this.state.models.filter((model: IModelPublisher) => {
        return (
          model.ID === currentTarget.dataset.value || '' + model.ID === currentTarget.dataset.value
        );
      })[0];

      // if int, let's get the pub
      if (typeof model.ID === 'number') {
        getPublisher({
          query: {
            publisher_id: model.ID,
          },
        }).then((publisher: IPublisher) => {
          if (this.props.onSelect) {
            this.props.onSelect(publisher);
          }
          this.setState({
            model: publisher,
            openSearch: false,
          });
        });
      } else {
        if (this.props.onSelect) {
          this.props.onSelect(model);
        }
        this.setState({
          model,
          openSearch: false,
        });
      }
    };

    clearSelected = () => {
      if (this.props.onSelect) {
        this.props.onSelect(undefined);
      }
      this.setState({
        site: undefined,
        openSearch: false,
      });
    };

    onChange = ({ currentTarget }: React.ChangeEvent<HTMLInputElement>) => {
      const query = currentTarget.value.trim();
      this.setState({
        existingQuery: query,
      });

      this.requestModels(query);
    };

    componentDidMount() {
      this.requestModels(''); // query with empty string to request all publishers with same reseller id
    }

    componentDidUpdate(nextProps: any) {
      if (this.props.model !== this.state.model) {
        this.setState({
          model: this.props.model,
        });
      }
      if (this.props.search !== nextProps.search) {
        this.requestModels('');
      }
    }

    render() {
      const { classes, TextFieldProps, InputLabelProps, InputProps, appendReseller } = this.props;
      const filteredModels = this.state.models.filter(
        (pub: IPublisher) => pub.Active === ResourceActiveEnabled,
      );
      return (
        <div>
          <div>
            <TextField
              {...TextFieldProps}
              label={this.props.label}
              helperText={this.props.helperText}
              value={this.renderSelectedModel(appendReseller || false)}
              onClick={this.handleOpenSearch}
              margin='none'
              InputLabelProps={InputLabelProps}
              InputProps={{
                id: 'publisher_select',
                ...InputProps,
                ...{ style: { fontSize: fontSizing.small } }, // NEW CHANGE
                inputRef: (node: HTMLInputElement) => {
                  this.anchorEl = node;
                },
                endAdornment: this.props.clear && (
                  <Icon classes={{ root: classes.clearButton }} onClick={this.clearSelected}>
                    close
                  </Icon>
                ),
              }}
            />
          </div>
          <Popper
            open={this.state.openSearch}
            anchorEl={this.anchorEl}
            placement='bottom-start'
            disablePortal
            className={classes.popper}
          >
            <Paper>
              <ClickAwayListener onClickAway={this.handleCloseSearch}>
                <div style={{ padding: '1rem' }}>
                  <TextField
                    InputProps={{
                      ref: this.searchInputRef,
                      autoFocus: true,
                      classes: {
                        root: classes.searchInputRoot,
                      },
                    }}
                    onChange={this.onChange}
                    className={classes.input}
                    fullWidth
                    helperText={this.props.searchHelperText}
                  />
                </div>
              </ClickAwayListener>
              <MenuList style={{ minHeight: '400px', maxHeight: '50vh', overflowX: 'scroll' }}>
                {this.state.searchInprogress ? (
                  <MenuItem disableRipple disableTouchRipple>
                    Searching...
                  </MenuItem>
                ) : (
                  filteredModels.map((model: IModelPublisher) => {
                    return (
                      <MenuItem
                        key={'k_' + model.ID}
                        onClick={this.selectModel}
                        data-value={model.ID}
                      >
                        {this.renderModel(model, appendReseller || false)}
                      </MenuItem>
                    );
                  })
                )}
              </MenuList>
            </Paper>
          </Popper>
        </div>
      );
    }
  },
) as React.ComponentType<IProps>;
